import React from 'react';
import './footer.css';
import gpt3Logo from '../../assets/inovatislogo.svg';

function Footer (){
    return (
        <footer>
          <div className='gpt3__footer section_padding'>
      <div className='gpt3__footer-heading'>
        <h1>
          INOVATIS MZ LTD
        </h1>
      </div>
        {/* <div className='gpt3__footer-btn'>
           <p>Request Early Access</p> 
        </div> */}

        <div className='gpt3__footer-links'>
          <div className='gpt3__footer-links_logo'>
            <img src={gpt3Logo} alt="logo" />
            <p>INOVATIS MZ LTD - Inovação e Tecnologia para Moçambique</p>
            <p>África, Moçambique. Todos os Direitos Reservados</p>
          </div>

          <div className='gpt3__footer-links_div'>
            <h4>Empresa</h4>
            <p>Sobre Nós</p>
            <p>Nossos Produtos</p>
            <p>Serviços</p>
            <p>Carreiras</p>
          </div>

          <div className='gpt3__footer-links_div'>
            <h4>Siga-nos</h4>
            <p>Facebook</p>
            <p>Instagram</p>
            <p>LinkedIn</p>
            <p><a href="privacy.php" style={{ color: '#000000' }}>Políticas de Privacidade</a></p>
          </div>

          <div className='gpt3__footer-links_div'>
            <h4>Contacte-nos</h4>
            <p>Maputo, Moçambique</p>
            <p>+258 85 0110 300</p>
            <p>apoio@inovatis.co.mz</p>
            <p>www.inovatis.co.mz</p>
          </div>
        </div>

        <div className='gpt3__footer-copyright'>
          <p>© 2026 INOVATIS MZ LTD. Todos os Direitos Reservados.</p>
        </div>

      
    </div>
        </footer>

    )

}

export default Footer